import { render, staticRenderFns } from "./_profile.vue?vue&type=template&id=b5bc9134"
import script from "./_profile.vue?vue&type=script&lang=js"
export * from "./_profile.vue?vue&type=script&lang=js"
import style0 from "./_profile.vue?vue&type=style&index=0&id=b5bc9134&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports